// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2PMgn","header":"ClearentDisclaimer_header__1ztDE","inner":"ClearentDisclaimer_inner__1rCI2"};